import Vue from "vue";
import Vuex from "vuex";
import Router from "vue-router";

import store from "./store";
import { bus } from "./main";
import Login from "./views/Login.vue";
import Home from "./views/Home.vue";
import Users from "./views/Users.vue";
import Companies from "./views/Companies.vue";
import Settings from "./views/Settings.vue";
import ReviewsSettings from "./views/ReviewsSettings.vue";
import Journeys from "./views/Journeys.vue";
import Response from "./views/Response.vue";
import Log from "./views/Log.vue";
import JourneyResults from "./views/JourneyResults.vue";
import RelevantCasting from "./views/RelevantCasting.vue";
import Clients from "./views/Clients.vue";
import Barometers from "./views/Barometers.vue";
import Unsubscribe from "./views/Unsubscribe.vue";
import Dossier from "./views/Dossier.vue";
import Pricelist from "./views/Pricelist.vue";
import Photowall from "./views/Photowall.vue";
import Clientrating from "./views/CheckRating.vue";
import ClientQueue from "./views/ClientQueue.vue";
import JourneyImprovements from "./views/JourneyImprovements.vue";
import onlineSalonhub from "./views/onlineClientsSalonhub.vue";
import RelevantPlayer from "./views/RelevantPlayer.vue";
import Receipts from "./views/Receipts.vue";
import WidgetSettings from "./views/WidgetSettings.vue";
import WidgetStats from "./views/WidgetStats.vue";
import PiggySocial from "./views/PiggySocial.vue";
import CompetenceSettings from "./views/CompetenceSettings.vue";
import CompetenceStats from "./views/CompetenceStats.vue";
import Account from "./views/Account.vue";
import CompetenceSchedules from "./views/CompetenceSchedules.vue";
import CompetenceDossier from "./views/CompetenceDossier.vue";
import SmsMessages from "./views/SmsMessages.vue"
import SmsMessagesSettings from "./views/SmsMessagesSettings.vue"
import Surveys from "./views/Surveys.vue"
import Memberships from "./views/MembershipForms.vue"
import MedicalIntake from "./views/MedicalIntakeForms.vue"
import MauticLists from "./views/MauticLists.vue"
import ConsentForms from "./views/ConsentForms.vue"
import ComplainForms from "./views/ComplainForms.vue"
import WidgetReports from "./views/WidgetReports.vue";


Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      meta: {
        title: "Home - Pillarrr"
        // metaTags: [
        //   {
        //     name: 'description',
        //     content: 'The about page of our example app.'
        //   },
        //   {
        //     property: 'og:description',
        //     content: 'The about page of our example app.'
        //   }
        // ]
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/dossier",
      name: "Dossier",
      component: Dossier,
      props: route => ({
        caller: route.query.caller,
        id: route.query.id
      }),
      meta: {
        title: "Dossier - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/abonnementen",
      name: "Abonnementen",
      component: Memberships,
      meta: {
        title: "Abonnementen - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },

    {
      path: "/toestemmingen",
      name: "Consent Forms",
      component: ConsentForms,
      meta: {
        title: "Toestemmingsformulieren - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },

    {
      path: "/klachten",
      name: "Klachten",
      component: ComplainForms,
      meta: {
        title: "Klachten - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },

    {
      path: "/medical-intake",
      name: "Medische Intake",
      component: MedicalIntake,
      meta: {
        title: "Medische Intake - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },

    {
      path: "/mautic-lijsten",
      name: "Mautic Lijsten",
      component: MauticLists,
      meta: {
        title: "Mautic Lijsten - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },

    {
      path: "/surveys",
      name: "Surveys",
      component: Surveys,
      props: route => ({
        caller: route.query.caller,
        id: route.query.id
      }),
      meta: {
        title: "Surveys - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/sms-berichten",
      name: "SMS-berichten",
      component: SmsMessages,
      meta: {
        title: "SMS-berichten - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/sms-berichten-instellingen",
      name: "Instellingen sms-berichten",
      component: SmsMessagesSettings,
      meta: {
        title: "Instellingen sms-berichten - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/account",
      name: "Account",
      component: Account,
      meta: {
        title: "Account - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/relplayer",
      name: "RelevantPlayer",
      component: RelevantPlayer,
      props: route => ({
        compId: route.query.id
      }),
      meta: {
        title: "RelevantPlayer - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/clientqueue",
      name: "Wachtlijst",
      component: ClientQueue,
      props: route => ({
        caller: route.query.caller
      }),
      meta: {
        title: "Wachtlijst - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/journey-results",
      name: "Resultaten",
      component: JourneyResults,
      meta: {
        title: "Resulaten reviews - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/journey-improvements",
      name: "Verbeteringen",
      component: JourneyImprovements,
      meta: {
        title: "Verbeteringen Reviews - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/barometers",
      name: "Barometers",
      component: Barometers,
      meta: {
        title: "Barometers - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/kassabonnen",
      name: "Digitale bonnen",
      component: Receipts,
      meta: {
        title: "Bonnen - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/relevantcasting",
      name: "RelevantCasting",
      component: RelevantCasting,
      meta: {
        title: "RelevantCasting - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        title: "Inloggen - Pillarrr"
      },
      props: route => ({
        destination: route.query.d
      }),
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/photowall",
      name: "Foto's",
      component: Photowall,
      meta: {
        title: "Photo's- Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/clientrating",
      name: "Beoordelingsoverzicht",
      component: Clientrating,
      props: route => ({
        surveyID: route.query.id
      }),
      meta: {
        title: "Client Rating"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/response",
      name: "Beoordeling",
      component: Response,
      props: route => ({
        id: route.query.id,
        answerdQuestionRating: route.query.qrt,
        answerdQuestionId: route.query.qid
      }),
      meta: {
        title: "Bedankt voor uw beoordeling"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/unsubscribe",
      name: "Uitschrijven",
      component: Unsubscribe,
      props: route => ({
        id: route.query.id
      }),
      meta: {
        title: "Uitschrijven"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/users",
      name: "Gebruikers",
      component: Users,
      beforeEnter(to, from, next) {
        if (store.state.userRole == "superadmin") {
          console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/home");
        }
      },
      meta: {
        title: "Gebruikers - Pillarrr"
      }
    },
    {
      path: "/log",
      name: "Log",
      component: Log,
      beforeEnter(to, from, next) {
        if (store.state.userRole == "superadmin") {
          console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/home");
        }
      },
      meta: {
        title: "Log - Pillarrr"
      }
    },
    {
      path: "/online-afspraken",
      name: "Online afspraken zonder klantenkaart",
      component: onlineSalonhub,
      meta: {
        title: "Online afspraken zonder klantenkaart - Pillarrr"
      }
    },
    {
      path: "/companies",
      name: "Bedrijven",
      component: Companies,
      beforeEnter(to, from, next) {
        if (store.state.userRole == "superadmin") {
          console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/home");
        }
      },
      meta: {
        title: "Bedrijven - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/journeys",
      name: "Reviews",
      component: Journeys,
      meta: {
        title: "Journeys - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/clients",
      name: "Klanten",
      component: Clients,
      meta: {
        title: "Klanten - Pillarrr"
      },
      beforeEnter(to, from, next) {
        next();
      }
    },
    {
      path: "/algemene-instellingen",
      name: "Algemene instellingen",
      component: Settings,
      beforeEnter(to, from, next) {
        if (
          store.state.userRole == "superadmin" ||
          store.state.userRole == "admin" ||
          store.state.userRole == "manager"
        ) {
          console.log("Autorized to access this page");
          next();
        } else {
          console.log("Not autorized to access this page");
          next("/home");
        }
      },
      meta: {
        title: "Algemene instellingen - Pillarrr"
      }
    },
    {
      path: "/reviews-instellingen",
      name: "Reviews instellingen",
      component: ReviewsSettings,
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Review instellingen - Pillarrr"
      }
    },
    {
      path: "/widget-instellingen",
      name: "Widget instellingen",
      component: WidgetSettings,
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Widget instellingen - Pillarrr"
      }
    },
    {
      path: "/widget-statistieken",
      name: "Widget statistieken",
      component: WidgetStats,
      props: route => ({
        urlStart: route.query.start,
        urlEnd: route.query.end
      }),
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Widget Statistieken - Pillarrr"
      }
    },

    {
      path: "/widget-reports",
      name: "Widget Reports",
      component: WidgetReports,
      props: route => ({
        urlStart: route.query.start,
        urlEnd: route.query.end
      }),
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Widget Reports - Pillarrr"
      }
    },

    
    {
      path: "/competenties-dossier",
      name: "Competenties dossier",
      component: CompetenceDossier,
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Competenties Dossiers - Pillarrr"
      }
    },

    {
      path: "/competenties-overzicht",
      name: "Competenties overzicht",
      component: CompetenceStats,
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Competenties Overzicht - Pillarrr"
      }
    },
    {
      path: "/competenties-instellingen",
      name: "Competenties instellingen",
      component: CompetenceSettings,
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Competenties Instellingen - Pillarrr"
      }
    },
    {
      path: "/competenties-planning",
      name: "Competenties planning",
      component: CompetenceSchedules,
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Competenties planning - Pillarrr"
      }
    },
    {
      path: "/piggysocial",
      name: "Piggy Social spaarders",
      component: PiggySocial,
      beforeEnter(to, from, next) {
        next();
      },
      meta: {
        title: "Piggy Social Spaarders - Pillarrr"
      }
    }
  ]
});


